import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _deleteMemberReportsRequest = {};
var _deleteMemberReportsResponse = {};
var _listReportedMembersRequest = {};
var _listReportedMembersResponse = { reportedMembers: '_reportedMember' };
var _markMemberReportsAsReviewedRequest = {};
var _markMemberReportsAsReviewedResponse = {
    reportedMember: '_reportedMember',
};
var _memberReport = { createdDate: 'google.protobuf.Timestamp' };
var _queryMemberReportsRequest = {};
var _queryMemberReportsResponse = { memberReports: '_memberReport' };
var _queryReportedMembersRequest = {};
var _queryReportedMembersResponse = { reportedMembers: '_reportedMember' };
var _reportedMember = { lastReportDate: 'google.protobuf.Timestamp' };
var _reportMemberRequest = { memberReport: '_memberReport' };
var _reportMemberResponse = { memberReport: '_memberReport' };
function resolveComWixpressMembersMemberreportsMemberReportsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/members-reports-api',
                destPath: '',
            },
        ],
        'members.wixapps.net': [
            {
                srcPath: '/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
        _: [
            {
                srcPath: '/members/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/members/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a report for the reported member. */
export function reportMember(payload) {
    var _a = serializer(_reportMemberRequest, { _memberReport: _memberReport }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportMemberResponse, {
        _memberReport: _memberReport,
    }).fromJSON;
    function __reportMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_report',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberreports.MemberReports.ReportMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportMember.fromReq = fromReq;
    __reportMember.__isAmbassador = true;
    return __reportMember;
}
/**
 * Retrieves a list of member reports, given the provided paging, filtering, and sorting.
 *
 * Query Member Reports runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 *
 * For field support for filters and sorting, see [Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/members-contacts/members/member-reports/filter-and-sort).
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging), and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
 */
export function queryMemberReports(payload) {
    var _a = serializer(_queryMemberReportsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMemberReportsResponse, {
        _memberReport: _memberReport,
    }).fromJSON;
    function __queryMemberReports(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_report',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberreports.MemberReports.QueryMemberReports',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMemberReports.fromReq = fromReq;
    __queryMemberReports.__isAmbassador = true;
    return __queryMemberReports;
}
/** Marks all reports of a member as reviewed. */
export function markMemberReportsAsReviewed(payload) {
    var _a = serializer(_markMemberReportsAsReviewedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markMemberReportsAsReviewedResponse, { _reportedMember: _reportedMember }).fromJSON;
    function __markMemberReportsAsReviewed(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_report',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberreports.MemberReports.MarkMemberReportsAsReviewed',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members/{memberId}/mark-as-reviewed',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markMemberReportsAsReviewed.fromReq = fromReq;
    __markMemberReportsAsReviewed.__isAmbassador = true;
    return __markMemberReportsAsReviewed;
}
/**
 * Retrieves a list of reported members.
 * @deprecated It has been replaced with wix.members.reports.v1.MemberReportOverviews.QueryMemberReportOverviews(), and will be removed on 2025-01-31.
 */
export function listReportedMembers(payload) {
    var _a = serializer(_listReportedMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listReportedMembersResponse, {
        _reportedMember: _reportedMember,
    }).fromJSON;
    function __listReportedMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_report',
            method: 'GET',
            methodFqn: 'com.wixpress.members.memberreports.MemberReports.ListReportedMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listReportedMembers.fromReq = fromReq;
    __listReportedMembers.__isAmbassador = true;
    return __listReportedMembers;
}
/**
 * Retrieves a list of reported members, given the provided paging, filtering, and sorting.
 *
 * Query Reported Members runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 *
 * For field support for filters and sorting, see [Supported Filters and Sorting]().
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @deprecated It has been replaced with wix.members.reports.v1.MemberReportOverviews.QueryMemberReportOverviews(), and will be removed on 2025-01-31.
 */
export function queryReportedMembers(payload) {
    var _a = serializer(_queryReportedMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReportedMembersResponse, {
        _reportedMember: _reportedMember,
    }).fromJSON;
    function __queryReportedMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_report',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberreports.MemberReports.QueryReportedMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReportedMembers.fromReq = fromReq;
    __queryReportedMembers.__isAmbassador = true;
    return __queryReportedMembers;
}
/** Deletes all reports of a member. */
export function deleteMemberReports(payload) {
    var _a = serializer(_deleteMemberReportsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberReportsResponse, {}).fromJSON;
    function __deleteMemberReports(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_report',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.memberreports.MemberReports.DeleteMemberReports',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberReports.fromReq = fromReq;
    __deleteMemberReports.__isAmbassador = true;
    return __deleteMemberReports;
}
//# sourceMappingURL=http.impl.js.map